import { TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';

const EditItem = ({ onFormSelectChange, onFormSubmit, onFormFieldChange }) => {
    const [inputFields, setInputFields] = useState([{
        price: '',

    }]);

    const [variant, setVariant] = useState(false)


    const addInputField = () => {
        setVariant(true)
        setInputFields([...inputFields, {
            price: '',
        }])
        console.log(inputFields)

    }
    return (
        <div className='edit-item'>
            <div style={{ height: "300vh" }}>
                <form>
                    <div className="card rounded-0 mb-0">
                        <div className="card-header">
                            <h5>Item Details</h5>
                        </div>
                        <div className="card-rounded-0 upload-item-card mt-3">
                            <div className="card-body upload-body">

                            </div>
                        </div>
                        <div className="card-body">
                            <small>Give your item a name and description</small>
                            <br />
                            <div className="form-group input-item mt-2">
                                <label htmlFor="">Item Name *</label>
                                <input type="text" name="name" onChange={onFormFieldChange} id='item_name' />
                                <small>Example: Cheese Pizza, Fried Rice,Apple Juice</small>
                            </div>
                            <div className="form-group input-item mt-2">
                                <label htmlFor="">Item Description-(optional)</label>
                                <input type="text" onChange={onFormFieldChange} id='item_description' />
                                <small>Example: Cheese Pizzais very tasty</small>
                            </div>
                            <div className="form-group input-item mt-2">
                                <label htmlFor="">Category</label>
                                <select id="category" onChange={onFormSelectChange}>
                                    <option value="donotCook" selected> Bevarage </option>
                                    <option value="cooking"> Special Deals </option>
                                    <option value="cooking"> Panda Deals </option>
                                    <option value="cooking"> New Deals </option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="card-rounded-0 add-item-card mt-3">
                        <div className="card-body">
                            <h5>Prices and Variation</h5>
                            <small className='mt-1'> Add a variation if this item comes in different Sizes(e.g. Small, Medium, Large) or options (e.g Soup, Dry) include GST/VAT in prices if applicable.</small>

                            {!variant &&
                                <div className=" mb-4 mt-5">
                                    <TextField
                                        id="price"
                                        defaultValue="Tk"
                                        label="Price *"
                                        type="number"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        variant="standard"
                                    />
                                </div>

                            }

                            {
                                variant &&
                                inputFields.map((data, index) =>
                                    <div key={index} className='card rounded-0 border mt-3 pl-3'>
                                        <div className=" mt-3">
                                            <TextField id="standard-basic" label="Variation Name" variant="standard" />
                                        </div>

                                        <div className="mt-5 mb-4">
                                            <TextField
                                                id="price"
                                                label="Price *"
                                                type="number"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                variant="standard"
                                            />
                                        </div>
                                    </div>
                                )

                            }
                            <span onClick={addInputField} style={{ color: '#58abd4' }}> <i className='mdi mdi-plus'></i>  ADD VARIATIONS</span>
                        </div>
                    </div>


                    <div className="card-rounded-0 add-item-card mt-3">
                        <div className="card-body">
                            <h5>Choice Groupes</h5>

                            <table className='table'>
                                <thead>
                                    <tr>
                                        <td>Name</td>
                                        <td>Choices</td>
                                    </tr>

                                </thead>
                                <tbody>
                                    <tr>
                                        <td className=' d-flex align-items-center'>
                                            <input type='checkbox' />
                                            <span className='ms-2'>choose your Salad</span>
                                        </td>
                                        <td>
                                            <span>Chicken BBQ salad, Chicken Tikka salad... </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className=' d-flex align-items-center'>
                                            <input type='checkbox' />
                                            <span className='ms-2'>choose your Salad</span>
                                        </td>
                                        <td>
                                            <span>Chicken BBQ salad, Chicken Tikka salad... </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditItem;